import { h } from 'preact';
import * as BaseComp from 'components/bolt/home/home.js';
import { joinClasses, accessNested } from 'utils/utils';
import Store from 'store/store';
import headerExpandedStyle from 'components/bolt/header/headerExpanded.sss';
import s from 'components/bolt/home/home.sss';

export default class Home extends BaseComp.default {
	toggleRegionSelector() {
		Store.emit('TOGGLE_REGION_SELECTOR');
	}

	renderRegionSelector() {
		const regionData = accessNested(this.props, 'appData.meta.region') || {};
		const regionSelectorCustomisation = accessNested(this.props, 'appData.header.powsterHeader.regionSelector.extraRegions', {});
		const currentRegionNameOverride = regionSelectorCustomisation[regionData.slug] || {};
		let currentRegionLabel = currentRegionNameOverride.label || regionData.slug;
		const useLanguage = this.props?.appData?.header?.powsterHeader?.regionSelector?.useLanguage;
		if (useLanguage) {
			currentRegionLabel = currentRegionNameOverride.label || regionData.languageFull || regionData.language;
		}
		const accessibilityCopy = accessNested(this.props.appData, 'copy.accessibilityCopy');
		return (
			<button
				class={joinClasses(headerExpandedStyle.regionSelectorButton, s.homeRegionSelector)}
				onClick={this.toggleRegionSelector}
				key="regionSelectorButton"
				ariaLabel={accessibilityCopy.$REGION_SELECTOR_BTN_ARIA}
			>
				<div class={headerExpandedStyle.icon} />
				<span class={headerExpandedStyle.name}>{currentRegionLabel}</span>
			</button>
		);
	}

	renderScrollArrow() {
		return this.renderRegionSelector();
	}

}
